import { render, staticRenderFns } from "./BillsList.vue?vue&type=template&id=5d14fbce&"
import script from "./BillsList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BillsList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BillsList.vue?vue&type=style&index=0&id=5d14fbce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports